import { createSlice, PayloadAction } from '@reduxjs/toolkit';

type ViewMode = 'desktop' | 'mobile';
type SidebarPanel = 'incidents' | 'resources' | 'personnel' | 'map' | 'none';

interface UiState {
  viewMode: ViewMode;
  sidebarOpen: boolean;
  sidebarPanel: SidebarPanel;
  commandPaletteOpen: boolean;
  rightPanelOpen: boolean;
  mapFullscreen: boolean;
  theme: 'dark' | 'light';
  mobileTab: 'dispatch' | 'incidents' | 'map' | 'profile';
  emergencyLocation: { latitude: number; longitude: number } | null;
}

const initialState: UiState = {
  viewMode: window.innerWidth >= 1024 ? 'desktop' : 'mobile',
  sidebarOpen: true,
  sidebarPanel: 'incidents',
  commandPaletteOpen: false,
  rightPanelOpen: true,
  mapFullscreen: false,
  theme: 'dark',
  mobileTab: 'dispatch',
  emergencyLocation: null,
};

const uiSlice = createSlice({
  name: 'ui',
  initialState,
  reducers: {
    setViewMode(state, action: PayloadAction<ViewMode>) {
      state.viewMode = action.payload;
    },
    toggleSidebar(state) {
      state.sidebarOpen = !state.sidebarOpen;
    },
    setSidebarPanel(state, action: PayloadAction<SidebarPanel>) {
      state.sidebarPanel = action.payload;
      state.sidebarOpen = true;
    },
    toggleCommandPalette(state) {
      state.commandPaletteOpen = !state.commandPaletteOpen;
    },
    toggleRightPanel(state) {
      state.rightPanelOpen = !state.rightPanelOpen;
    },
    toggleMapFullscreen(state) {
      state.mapFullscreen = !state.mapFullscreen;
    },
    setTheme(state, action: PayloadAction<'dark' | 'light'>) {
      state.theme = action.payload;
    },
    setMobileTab(state, action: PayloadAction<UiState['mobileTab']>) {
      state.mobileTab = action.payload;
    },
    setEmergencyLocation(state, action: PayloadAction<{ latitude: number; longitude: number } | null>) {
      state.emergencyLocation = action.payload;
    },
  },
});

export const {
  setViewMode,
  toggleSidebar,
  setSidebarPanel,
  toggleCommandPalette,
  toggleRightPanel,
  toggleMapFullscreen,
  setTheme,
  setMobileTab,
  setEmergencyLocation,
} = uiSlice.actions;
export default uiSlice.reducer;
